import {Component, OnDestroy, OnInit} from '@angular/core';
import {concat, Observable, of, Subscription} from 'rxjs';
import {delay, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {LoaderRequestService} from '@app/service/loader-request.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';

type LoaderBarState = 'loading' | 'finishing' | null;

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {
    // Barra superior para peticiones background (GET):
    // 'loading' = avanza lento hacia ~90%, 'finishing' = corre al 100% y se desvanece, null = oculta
    barState$: Observable<LoaderBarState>;
    private subscription = new Subscription();

    constructor(private loaderService: LoaderRequestService,
                private ngxService: NgxUiLoaderService) { }

    ngOnInit() {
        this.barState$ = this.loaderService.backgroundLoading$.pipe(
            distinctUntilChanged(),
            switchMap((loading: boolean, emissionIndex: number) => {
                if (loading) {
                    return of('loading' as LoaderBarState);
                }

                // El estado inicial no debe dibujar una barra ya completada.
                if (emissionIndex === 0) {
                    return of(null as LoaderBarState);
                }

                return concat(
                    of('finishing' as LoaderBarState),
                    of(null as LoaderBarState).pipe(delay(600))
                );
            })
        );

        this.subscription.add(
            this.loaderService.foregroundLoading$.subscribe((loading: boolean) => {
                if (loading) {
                    this.ngxService.start();
                } else {
                    this.ngxService.stop();
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
